import { Injectable } from "@angular/core";
import {
    TCI_APP_DETAIL_ENV_MENU_TYPE,
    TCI_APP_DETAIL_MONITORING_MENU_TYPE,
    TCI_COMPONENT_MODE,
    ITCIApplication,
    ITCITenantComponentOptions,
    TCITenantAppDetailsMenu
} from "@tci/common";
import { TciTenantService } from "../../ng-tenant/tci-tenant.service";
import { TciTenantComponentCacheService } from "../../ng-tenant/tci-tenant-component-cache.service";
import { TCITenantMenuServices } from "../../ng-tenant/tci-tenant.menu";
import { BaseAppDetailMenuComponentInput } from "../ng-app-details-menu";
import { NgUserService } from "../../ng-shared/ng-services/ng-user.service";
import { NgAppFeatureToggleService } from "../../ng-shared/ng-services/ng-app-feature-toggle.service";

import { Observable } from "rxjs";
import * as lodash from "lodash";

@Injectable()
export class NgSubmenuLeftService {
    // As long as this service is not a singleton the catalog would renew on each appDetails access
    private envMenuItems: ITCITenantComponentOptions<TCI_APP_DETAIL_ENV_MENU_TYPE>[];
    private monitorMenuItems: ITCITenantComponentOptions<TCI_APP_DETAIL_ENV_MENU_TYPE>[];

    constructor(
        private userSvc: NgUserService,
        private featureToggleService: NgAppFeatureToggleService,
        private tenantMenuSrv: TCITenantMenuServices,
        private tenantSvc: TciTenantService,
        private tenantCacheSvc: TciTenantComponentCacheService
    ) { }

    public getMenuItems(
        parentTabRouteId: string,
        app: ITCIApplication
    ): Observable<ITCITenantComponentOptions<TCI_APP_DETAIL_ENV_MENU_TYPE>[]> {
        return this.tenantSvc.onInit()
            .flatMap(() => {
                const input = new BaseAppDetailMenuComponentInput(
                    app.type, null, app, this.userSvc, this.featureToggleService, TCI_COMPONENT_MODE.COMP_MODE_APP_DETAIL_SUBMENU, null
                );

                switch (parentTabRouteId) {
                    case TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_ENVIRONMENT.getRouteId():
                        if (!this.envMenuItems) {
                            return this.tenantMenuSrv.getAppDetailEnvMenuItems(app.type, TCI_APP_DETAIL_ENV_MENU_TYPE.MAIN_MENU, input)
                                .map(res => {
                                    this.envMenuItems = res;
                                    return res;
                                });
                        }
                        return Observable.of(this.envMenuItems);
                    case TCITenantAppDetailsMenu.TCI_MENU_APP_DETAILS_MONITORING.getRouteId():
                        if (!this.monitorMenuItems) {
                            // tslint:disable-next-line: max-line-length
                            return this.tenantMenuSrv.getAppDetailMonitoringMenuItems(app.type, TCI_APP_DETAIL_MONITORING_MENU_TYPE.MAIN_MENU, input)
                                .map(res => {
                                    this.monitorMenuItems = res;
                                    return res;
                                });
                        }
                        return Observable.of(this.monitorMenuItems);

                    default:
                        return null;
                }
            });
    }

    public validateMenuItem(app: ITCIApplication, parentTabRouteId: string, menuItemRouteId: string): Observable<boolean> {
        return this.getMenuItems(parentTabRouteId, app)
            .map(items => items.find(item => item.getRouteId() === menuItemRouteId)) // Check if submenu item is part of the selected tab
            .map(item => {
                if (!lodash.isUndefined(item)) {
                    return !!this.tenantCacheSvc.getComponentFromCache(app.type, item.getComponentSelectorType());
                } else {
                    return false;
                }
            });
    }
}
